/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentOrganAtRisk from './treatment-organ-at-risk';
import TreatmentOrganAtRiskDetail from './treatment-organ-at-risk-detail';
import TreatmentOrganAtRiskUpdate from './treatment-organ-at-risk-update';
import TreatmentOrganAtRiskDeleteDialog from './treatment-organ-at-risk-delete-dialog';

const TreatmentOrganAtRiskRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentOrganAtRisk />} />
    <Route path="new" element={<TreatmentOrganAtRiskUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentOrganAtRiskDetail />} />
      <Route path="edit" element={<TreatmentOrganAtRiskUpdate />} />
      <Route path="delete" element={<TreatmentOrganAtRiskDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentOrganAtRiskRoutes;
